import { DollarSign } from 'lucide-react';
import { Badge } from '@/components/ui/badge';
import { EntityConfig } from '../types';

export interface MasterCurrency {
  id: string;
  code: string;
  display_name: string;
  symbol: string | null;
  is_active: boolean;
  sort_order: number;
  created_at: string;
}

export const masterCurrenciesConfig: EntityConfig<MasterCurrency> = {
  name: 'masterCurrencies',
  singularName: 'Currency',
  pluralName: 'Currencies',
  tableName: 'master_currencies',
  keyField: 'id',
  icon: <DollarSign className="h-4 w-4" />,
  description: 'Currency reference data',
  category: 'master',
  permissionModule: 'settings',

  columns: [
    {
      id: 'sort_order',
      header: 'Order',
      accessorKey: 'sort_order',
      sortable: true,
      width: '80px',
    },
    {
      id: 'code',
      header: 'Code',
      accessorKey: 'code',
      sortable: true,
      cell: (row) => <span className="font-mono text-sm">{row.code}</span>,
    },
    {
      id: 'display_name',
      header: 'Display Name',
      accessorKey: 'display_name',
      sortable: true,
    },
    {
      id: 'symbol',
      header: 'Symbol',
      accessorKey: 'symbol',
      cell: (row) => row.symbol ? (
        <span className="font-mono text-lg">{row.symbol}</span>
      ) : <span className="text-muted-foreground">-</span>,
    },
    {
      id: 'is_active',
      header: 'Status',
      accessorKey: 'is_active',
      width: '100px',
      cell: (row) => (
        <Badge variant={row.is_active ? 'default' : 'secondary'}>
          {row.is_active ? 'Active' : 'Inactive'}
        </Badge>
      ),
    },
  ],

  formFields: [
    {
      name: 'code',
      label: 'Code',
      type: 'text',
      required: true,
      placeholder: 'e.g., USD',
    },
    {
      name: 'display_name',
      label: 'Display Name',
      type: 'text',
      required: true,
      placeholder: 'e.g., US Dollar',
    },
    {
      name: 'symbol',
      label: 'Symbol',
      type: 'text',
      placeholder: 'e.g., $',
    },
    {
      name: 'sort_order',
      label: 'Sort Order',
      type: 'number',
      defaultValue: 0,
    },
    {
      name: 'is_active',
      label: 'Active',
      type: 'switch',
      defaultValue: true,
    },
  ],

  searchFields: ['code', 'display_name', 'symbol'],
  defaultOrderBy: { field: 'sort_order', ascending: true },

  features: {
    canCreate: true,
    canUpdate: true,
    canDelete: true,
    canBulkDelete: false,
    showActivityLog: false,
  },
};
